import React, { forwardRef } from "react";
import { P, SectionMainWrapper, SectionSubHeading } from "../../../Styles/style";
import mainimg from "../../../../assets/images/mainimg.png"
import { Container, Grid, useTheme } from "@mui/material";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import {BuyNow, SectionHeading } from "./styles";
import styled from "@emotion/styled";
import video from "../../../../assets/images/pulse.mp4"
const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const Otcimg = styled.img`
width:100%;
height:auto;
max-width:440px;
  position:absolute;
  top:21%;
  @media screen and (min-width:1800px){
    top:12%;
  }
  @media screen and (max-width:900px){
    top:32%;
  }
  @media screen and (max-width:500px){
    position:UNSET;
  }
`
const DIV = styled.div`
  height:230px;
  
  display: flex;
    justify-content: center;
  
  @media screen and (max-width:500px){
    height:UNSET;
  }
`
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`;
const GridwRA = styled(Grid)`
/* position:relative; */
`
const Section1_Header = () => {
  
  const theme = useTheme()
  return (
    <>
      <div >
        <SectionMainWrapper p="6rem 0" id="home" align="center">
          <Container maxWidth="xl">

          <GridwRA container justifyContent="center">
              <GridwRA item xs={12} sm={12} md={10} lg={8} xl={7}>
            <SectionHeading p599="0" p="0 0" m="0" data-aos="flip-up" data-aos-easing="ease-in" data-aos-delay="400" data-aos-duration="600" data-aos-offset="0">
            WELCOME TO THE<br />
            SHIB REVOLUTION!
            </SectionHeading>
            {/* <DIV>
      <Otcimg data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="200"
                data-aos-duration="600"
                data-aos-offset="0" src={mainimg} />
            </DIV> */}
        
                </GridwRA>
                </GridwRA>
            {/* <SectionSubHeading p="0" m="0" align="center" data-aos="flip-up" data-aos-easing="ease-in" data-aos-delay="400" data-aos-duration="600" data-aos-offset="0">
              Buy $Pulse With $ETH
            </SectionSubHeading> */}
            <Grid container justifyContent="center">
              <Grid item xs={12} md={3}></Grid>
              <Grid item xs={12} sm={10}md={6}>
                {/* <P p="20px 0 40px" m="0" align="center" data-aos="flip-up" data-aos-easing="ease-in" data-aos-delay="500" data-aos-duration="500" data-aos-offset="0" >
                  Been wanting to get your hands on some $Pulse but can't find any reliable outlets?
                  You don't need to look around any more, with PULSE OTC you can easily swap out your Ethereum for $Pulse on the Pulse network.</P> */}
                <div data-aos="flip-up" data-aos-easing="ease-in" data-aos-delay="700" data-aos-duration="500" data-aos-offset="0" >
                  <BuyNow hoverbgColor={theme.pageColor} bgColor={theme.bgTertiary} style={{color:'#000'}} href="https://app.pulsex.com/swap?outputCurrency=0xDAd1C09b2680bb9c89b5ba1231076CA16c9eaaF4" target="_blank"><span /><span /><span /><span />Buy Now</BuyNow>
                  <BuyNow bgColor={theme.pageColor} brColor={theme.textPrimary} 
                  href="https://dexscreener.com/pulsechain/0x47ed34e27f961e00208980005ee9daeed9f2c02e" // target="_blank"
                  >
                    View Chart
                  </BuyNow>
                </div>
              </Grid>
              <Grid item xs={12} md={3}></Grid>
              <div>
              <VideoBK autoPlay loop muted>
              <source src={video} type="video/mp4" />
              </VideoBK>
              </div>

            </Grid>
          </Container>
        </SectionMainWrapper>

      </div>

    </>
  );
};

export default Section1_Header;
